import React, { Component } from 'react';

import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber
  } from "../../../commonFunctions";
  
  const rp363 = {
    label: "N Type Trial & Balance",
    starting: true,
    url: "rp363",
    pageLabel: "N Type Trial & Balance",
    pageType: "history",
    form: [
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Region",
        name: "",
        description: ""
      },
      {
        inputType: "autocomplete",
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        ajaxLoad: true,
        ajaxOptions: {
          value: "code",
          label: "descn",
          query: {
            dialect: "mysql",
            query: "getBranchName"
          }
        },
        options: [],
        //prepend:"Br.Name";
        placeHolder: "",
        name: "region",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Marathi",
        name: "marathi",
        description: ""
      },
    {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "Parent Branch",
        label: "Parent Branch",
        name: "parentbranch",
        description: "Enter Parent Branch"
      },
      {
        inputType: "autocomplete",
        default: "",
        elementProps: {
          stayOpen: false,
          removeSelected: true,
          disabled: false,
          rtl: false
        },
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        ajaxLoad: true,
        ajaxOptions: {
          value: "code",
          label: "descn",
          query: {
            dialect: "mysql",
            query: "getBranchName"
          }
        },
        options: [
          {
            label:"Branch",
            value:"Branch"
          }
        ],
        //prepend:"Br.Name";
        placeHolder: "Parent Branch ",
        name: "parentbranch",
        description: "Enter Parent Branch Code"
      },
      {
        inputType: "showdata",
        data: "parentbranch",
        textcolor: "black",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        }
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Show Tree Image",
        name: "showtreeimage",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "As on Date",
        name: "",
        description: ""
      },
      {
        inputType: "date",
        dateType: "ontype",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        displayFormat: "DD/MM/YYYY",
        outputFormat: "YYYYMMDD",
        placeHolder: "",
        label: "",
        name: "date1",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Summary",
        name: "Summary",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "As on Date",
        name: "",
        description: ""
      },
      {
        inputType: "date",
        dateType: "ontype",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        displayFormat: "DD/MM/YYYY",
        outputFormat: "YYYYMMDD",
        placeHolder: "",
        label: "",
        name: "date2",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-4",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Without GL",
        name: "withoutgl",
        description: ""
      },
      {
        inputType: "displaytext",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Amount Rounded In",
        name: "",
        description: ""
      },
      {
        inputType: "select",
        isRequired: true,
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        options:[
            {
                label:"Hundreds",
                value:"Hundreds"
            },
            {
                label:"Thousands",
                value:"Thousands"
            },
            {
                label:"Ten-Thousands",
                value:"Ten-Thousands"
            },
            {
                label:"Lakhs",
                value:"Lakhs"
            }
        ],
        placeHolder: "Amount Rounded In",
        label: "",
        name: "amtround",
        description: "Enter Amount Rounded In"
      },
    ]
}
export default rp363